import tonStyles from './../ton.json'

export default {
  name: '4',
  type: 'Paragraph',
  color: tonStyles.colors.PrimaryBlack
}
